module.exports = new __parcel__URL__("doom-2016.d579ad93.jpg").toString();